import type { Warbond } from "@hd2/data";
import { useEffect, useState } from "react";

let cache: Warbond[] | null = null;
let pending: Promise<Warbond[]> | null = null;

async function fetchWarbonds(): Promise<Warbond[]> {
	if (cache) {
		return cache;
	}
	if (!pending) {
		pending = fetch("/api/warbonds")
			.then((r) => r.json() as Promise<{ warbonds: Warbond[] }>)
			.then((data) => {
				cache = data.warbonds;
				return cache;
			});
	}
	return pending;
}

export function useWarbonds(): {
	warbonds: Warbond[];
	loading: boolean;
} {
	const [warbonds, setWarbonds] = useState<Warbond[]>(() => cache ?? []);
	const [loading, setLoading] = useState(cache === null);

	useEffect(() => {
		if (cache) {
			setWarbonds(cache);
			setLoading(false);
			return;
		}
		let alive = true;
		fetchWarbonds()
			.then((list) => {
				if (alive) {
					setWarbonds(list);
					setLoading(false);
				}
			})
			.catch(() => {
				if (alive) {
					setLoading(false);
				}
			});
		return () => {
			alive = false;
		};
	}, []);

	return { warbonds, loading };
}
